/**
 * @generated SignedSource<<5d2eb1914432596acaf71cb21bcb6841>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductImage_photo$data = {
  readonly masterOrZoomPath: string | null;
  readonly smallPath: string | null;
  readonly versions: ReadonlyArray<{
    readonly webPath: string | null;
  } | null> | null;
  readonly " $fragmentType": "ProductImage_photo";
};
export type ProductImage_photo$key = {
  readonly " $data"?: ProductImage_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_photo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductImage_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemPhoto",
  "abstractKey": null
};

(node as any).hash = "2ff1c7beea8331e8fa5c981f641921e1";

export default node;
